<template>
  <div style="width: 100%">

    <!--下载的灰色条-->
    <div class="downloadBar">
      <hr/>
      <div class="gray">
        <Row>
          <Col :xs="24" :sm="24" :md="12" :lg="6"><img src="../assets/software1.png" alt="启明瞳"></Col>
          <Col  :xs="24" :sm="24" :md="12" :lg="18">
          <Row><Col><p>启明瞳，点亮盲人的生活</p></Col></Row>
          <Row style="padding-top: 10px">
            <Col span="12"><Button type="primary" ghost size="large" style="width: 130px" @click.native="androidDown">安卓下载</Button></Col>
            <Col span="12"><Button type="primary" ghost size="large" style="width: 130px" @click.native="iosDown">ios下载</Button></Col>
          </Row>
          </Col>
        </Row>
      </div>
    </div>

    <!--视频-->
    <div class="video" style="width: 80%">
      <video-player class="vjs-custom-skin" :options="playerOptions"></video-player>
    </div>

    <!--文字描述-->
    <div class="description">
      <p>
        一些文字描述，........................................................................................................................................................................<br />
        一些文字描述，........................................................................................................................................................................<br />
        一些文字描述，........................................................................................................................................................................<br /><br /><br />
        一些文字描述，........................................................................................................................................................................<br />
        一些文字描述，........................................................................................................................................................................<br />
        一些文字描述，........................................................................................................................................................................<br />
        一些文字描述，........................................................................................................................................................................<br />
        一些文字描述，........................................................................................................................................................................<br />
        一些文字描述，........................................................................................................................................................................<br />
        一些文字描述，........................................................................................................................................................................<br />
        一些文字描述，........................................................................................................................................................................<br />
      </p>
    </div>

    <!--分享按钮-->
    <div class="share">
      <Row style="margin-bottom: 2%">
        <Col span="12" style="text-align: right;padding-right: 2%">
        <Button type="primary" size="large" style="width: 130px" @click.native="QQshare">分享至QQ
          <img src="../assets/QQ.png" alt="">
        </Button>
        </Col>
        <Col span="12" style="text-align: left;padding-left: 2%">
        <Button type="primary" size="large" style="width: 130px" @click.native="weCharShare">分享至微信
          <img src="../assets/weChat.png" alt="">
        </Button>
        </Col>
      </Row>
    </div>

  </div>
</template>

<script>
  //引入video样式
  import 'video.js/dist/video-js.css'
  import 'vue-video-player/src/custom-theme.css'
  //引入hls.js
  import 'videojs-contrib-hls.js/src/videojs.hlsjs'

  export default {
    name: "communityDetail",
    data() {
      return {
        playerOptions: {
          playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
          autoplay: false, //如果true,浏览器准备好时开始回放。
          controls: true, //控制条
          preload: 'auto', //视频预加载
          muted: false, //默认情况下将会消除任何音频。
          loop: false, //导致视频一结束就重新开始。
          language: 'zh-CN',
          aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
          fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
          sources: [{
            type: 'video/mp4',
            src: 'http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4'
          }],
          poster: "http://static.smartisanos.cn/pr/img/video/video_03_cc87ce5bdb.jpg", //你的封面地址
          width: document.documentElement.clientWidth,
          notSupportedMessage: '此视频暂无法播放，请稍后再试' //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        }
      }
    },
    methods:{
      androidDown(){
      },/*安卓下载*/
      iosDown(){
      },/*ios下载*/
      QQshare(){

      },/*分享至QQ*/
      weCharShare(){

      }/*分享至微信*/
    }
  }
</script>

<style scoped>
  .downloadBar hr{
    width:100%;
    border-top:1px solid #ccc;
    border-bottom: 0;
  }/*顶部的横线*/
  .downloadBar .gray{
    width: 80%;
    background-color: rgba(242, 242, 242, 1);
    margin: 2% auto;
  }/*灰色块*/
  .downloadBar .gray img{
    padding: 2%;
    width: 150px;
    height: 150px;
  }/*灰色条的图片*/
  .downloadBar .gray p{
    font-weight: bold;
    font-size: 1rem;
    color: #000;
    padding-top: 50px;
  }/*灰色条的文字*/
  .video{
    width: 100%;
    margin: 2% auto;
    text-align: center;
  }
  .description{
    width: 100%;
    margin: 2% auto;
  }
  .description p{
    color: rgba(80, 80, 80, 1);
    text-align: center;
  }
  .share img{
    width: 30px;
    height: 30px;
  }

  /*手机竖屏*/
  @media only screen
  and (min-width: 320px)
  and (max-width: 767px)
  and (orientation: portrait){
    .downloadBar .gray p{
      padding-top: 0;
    }/*灰色条的文字*/
  }

  /*手机横屏*/
  @media only screen
  and (min-width: 320px)
  and (max-width: 767px)
  and (orientation: landscape){

  }

  /*平板竖屏*/
  @media only screen
  and (min-width: 768px)
  and (max-width: 1024px)
  and (orientation: portrait){

  }

  /*平板横屏*/
  @media only screen
  and (min-width: 768px)
  and (max-width: 1024px)
  and (orientation: landscape){

  }
</style>



// WEBPACK FOOTER //
// src/components/communityDetail.vue